import type { PartialCampaign } from '@/v2/services/sanity/utils/parser/campaign/parseCampaignPageData';
import type { UI } from '@/v2/types';
import React, { useEffect } from 'react';
import { Box } from '@qga/roo-ui/components';

import { DataLayerProvider } from '@shared/v2/contexts/DataLayerContext';

import { Layout } from '@/v2/components/layout/Layout';
import { Hero } from '@/v2/components/ui/Hero';
import usePageViewEvent from '@/v2/hooks/usePageViewEvent';
import DealsPageContent from '../../../../components/DealsPage/components/DealPageContent';
import { dealPageDataLayer } from './utils/dataLayer';

interface Props {
  importantInformation: Array<UI.ImportantInformation>;
  navigation: Array<UI.Navigation>;
  campaign: UI.Campaign;
  campaigns?: Array<PartialCampaign>;
  destinations: Array<Partial<UI.Destination>>;
  tiles: Array<Partial<UI.CampaignTile>>;
  warningMessage: UI.Message | null;
  informationMessage: UI.Message | null;
  marketingMessage: UI.MarketingMessage | null;
}

const dataLayerData = { pageName: 'Deals' };

const CampaignView = ({
  campaign,
  campaigns,
  destinations,
  tiles,
  ...rest
}: Props) => {
  useEffect(() => {
    dealPageDataLayer();
  }, []);

  usePageViewEvent({ type: 'campaign' });

  return (
    <DataLayerProvider value={dataLayerData}>
      <Layout {...rest}>
        <Box data-testid="CAMPAIGN_PAGE">
          <Hero {...campaign.hero!} />
          <DealsPageContent
            campaign={campaign}
            campaigns={campaigns}
            /* @ts-ignore Bad JSX types */
            destinations={destinations}
            /* @ts-ignore Bad JSX types */
            tiles={tiles}
          />
        </Box>
      </Layout>
    </DataLayerProvider>
  );
};

export default CampaignView;
